export default __webpack_public_path__ + "static/media/grey-denmark-map.6ba809ed.png";